export default import.meta.ROLLDOWN_FILE_URL_64ISZExJTzy5fs6mREot5g